export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_04-8fcb29153e0e1eb445e08de0f7603d9a.png";